module.exports = __webpack_public_path__ + "img/daman_crop1.5ce60086.jpeg";